export default __webpack_public_path__ + "static/media/tetrahedron.bdd2cd8c.jpg";